/**
 * ParentNode / ChildNode / isConnected shim — legacy (nomodule) bundle ONLY.
 *
 * WHY THIS EXISTS
 * Android 7.0's WebView is Chrome 53. prepend/append/before/after/replaceWith
 * and Node.isConnected all landed in Chrome 54. PrimeVue's style loader
 * (@primevue/core/usestyle) injects every component theme with
 * `document.head.prepend(style)`, so on Chrome 53 it throws
 * "h.head.prepend is not a function" inside a mounted hook: the form still
 * renders, but every PrimeVue input, radio and button comes out unstyled and
 * the Vue errorHandler posts a js_exception alert to #sentinel-alerts.
 * @primeuix/utils' createElement helper calls `el.append(...)` the same way.
 * Measured on the cs7_0 emulator against the live site, 2026-09-25 (prod
 * system_logs row: "h.head.prepend is not a function", /apply/3176383/cdl).
 *
 * core-js (which @vitejs/plugin-legacy injects) covers JS built-ins only,
 * never DOM methods, so this gap has to be filled by hand.
 *
 * SAME TWO HARD CONSTRAINTS AS dommatrix-legacy.js - do not "clean these up"
 *  1. PLAIN .js, ES5 ONLY. additionalLegacyPolyfills is built by a raw
 *     Rollup pass with NO transform; modern syntax aborts SystemJS on-device.
 *  2. No imports.
 *
 * Every definition is guarded, so a browser that already has the method is
 * untouched. Ships in polyfills-legacy only, so modern browsers pay nothing.
 */
;(function () {
  if (typeof window === 'undefined' || typeof Node === 'undefined') return

  function toFragment(args) {
    var frag = document.createDocumentFragment()
    for (var i = 0; i < args.length; i++) {
      var item = args[i]
      frag.appendChild(item instanceof Node ? item : document.createTextNode(String(item)))
    }
    return frag
  }

  function define(proto, name, fn) {
    if (!proto || Object.prototype.hasOwnProperty.call(proto, name) || name in proto) return
    Object.defineProperty(proto, name, {
      configurable: true,
      enumerable: true,
      writable: true,
      value: fn,
    })
  }

  var parents = [
    window.Element && Element.prototype,
    window.Document && Document.prototype,
    window.DocumentFragment && DocumentFragment.prototype,
  ]
  for (var p = 0; p < parents.length; p++) {
    define(parents[p], 'prepend', function prepend() {
      this.insertBefore(toFragment(arguments), this.firstChild)
    })
    define(parents[p], 'append', function append() {
      this.appendChild(toFragment(arguments))
    })
  }

  var children = [
    window.Element && Element.prototype,
    window.CharacterData && CharacterData.prototype,
    window.DocumentType && DocumentType.prototype,
  ]
  for (var c = 0; c < children.length; c++) {
    define(children[c], 'before', function before() {
      if (this.parentNode) this.parentNode.insertBefore(toFragment(arguments), this)
    })
    define(children[c], 'after', function after() {
      if (this.parentNode) this.parentNode.insertBefore(toFragment(arguments), this.nextSibling)
    })
    define(children[c], 'replaceWith', function replaceWith() {
      if (this.parentNode) this.parentNode.replaceChild(toFragment(arguments), this)
    })
  }

  // PrimeVue reads `style.isConnected` to decide whether to insert. Without it
  // the value is undefined and every style is re-inserted on every load.
  if (!('isConnected' in Node.prototype)) {
    Object.defineProperty(Node.prototype, 'isConnected', {
      configurable: true,
      enumerable: true,
      get: function () {
        var node = this
        while (node) {
          if (node.nodeType === 9) return true
          // Step out of a shadow root to its host; any other parentless node
          // is detached.
          node = node.parentNode || (node.nodeType === 11 && node.host ? node.host : null)
        }
        return false
      },
    })
  }
})()
